export default __webpack_public_path__ + "static/media/7c2a27aa0e8cf546.d440501ede37d1a5a820cf6f8871f0d5.svg";